import { List, Record } from 'immutable'
import { AssociatedContact, IAssociatedContact } from './AssociatedContact'
import { Attachment, IAttachment } from './Attachment'

export interface IDevelopmentClient {
  readonly id: string
  readonly attachments: List<IAttachment>
  readonly photos: List<IAttachment>
  readonly contacts: List<IAssociatedContact>
  readonly creator: string
  readonly name: string
  readonly logo?: IAttachment
  readonly logoId: string
  readonly isActive: boolean
  readonly slug: string
}

const DevelopmentClientRecord = Record({
  attachments: List<Attachment>(),
  contacts: List<AssociatedContact>(),
  creator: '',
  id: '',
  isActive: true,
  logo: undefined,
  logoId: '',
  name: '',
  photos: List<Attachment>(),
  slug: '',
})

export class DevelopmentClient extends DevelopmentClientRecord
  implements IDevelopmentClient {
  public static fromJS(initialState?: Partial<IDevelopmentClient>) {
    if (!initialState) {
      return new DevelopmentClient()
    }

    const { attachments, contacts, logo, photos, ...rest } = initialState

    return new DevelopmentClient({
      attachments: attachments
        ? List(attachments.map((a) => Attachment.fromJS(a)))
        : undefined,
      contacts: contacts
        ? List(contacts.map((a) => AssociatedContact.fromJS(a)))
        : undefined,
      logo: Attachment.fromJS(logo),
      photos: photos ? List(photos.map((a) => Attachment.fromJS(a))) : undefined,
      ...rest,
    })
  }

  public readonly id: string
  public readonly attachments: List<Attachment>
  public readonly photos: List<Attachment>
  public readonly contacts: List<AssociatedContact>
  public readonly creator: string
  public readonly name: string
  public readonly logo?: Attachment
  public readonly logoId: string
  public readonly isActive: boolean
  public readonly slug: string

  constructor(initialState?: Partial<DevelopmentClient>) {
    initialState ? super(initialState) : super()
  }
}
